class Certis {
    constructor() {
        this.max = 5;
        this.data = {
            current: 1,
            1: { status: false },
            3: { status: false },
            5: { status: false },
        };
    }

    next() {
        const { current } = this.data;
        if (current > this.max) {
            return 0;
        }
        this.data = {
            ...this.data,
            current: current + 2,
        };

        return this.data;
    }

    get id() {
        return this.data.current;
    }

    reset(current = 1) {
        this.data = {
            current: current,
            1: { status: false },
            3: { status: false },
            5: { status: false },
        };
    }
}

export default new Certis();
